import { ROOM } from "./layout";

export const SECTIONS = {
  love: { name: "Shringara", line: "where the heart aches", light: "Dusk", word: "Yearning", tint: "#E7A3D6", glow: "#FF7EB9" },
  nature: { name: "Prakriti", line: "where the heart blooms", light: "Dawn", word: "Bloom", tint: "#9ACB7C", glow: "#F6A5C8" },
  spirit: { name: "Bhakti", line: "where the heart prays", light: "Twilight", word: "Prayer", tint: "#F2B544", glow: "#5B4BC4" },
  thoughts: { name: "Manan", line: "where the heart wanders", light: "Midnight", word: "Reverie", tint: "#8FA8C8", glow: "#D4DEEC" },
  fire: { name: "Agni", line: "where the heart burns", light: "Noon", word: "Ember", tint: "#E8604C", glow: "#FFB238" },
};
export const MEANING = { fire: "passion", spirit: "devotion", nature: "nature", thoughts: "reflection", love: "love" };
// the English meaning beside every Hindi/Sanskrit feeling name, for a global audience
export const EN = { fire: "Passion", spirit: "Devotion", nature: "Nature", thoughts: "Reflection", love: "Love" };
export const feelingName = (id) => (SECTIONS[id] ? `${SECTIONS[id].name} · ${EN[id]}` : "");
export const BAND = { fire: "#E0574A", spirit: "#F0A93A", nature: "#7DB46A", thoughts: "#5A6FC0", love: "#C06AB0" };
export const RAINBOW_ORDER = ["fire", "spirit", "nature", "thoughts", "love"];
export const zoneLabel = (id) => (SECTIONS[id] ? `${feelingName(id)} — ${SECTIONS[id].line}` : "");
export const SECTION_IDS = ["love", "nature", "spirit", "thoughts", "fire"];

const { W, D } = ROOM;
export const PERIM = 2 * (W + D);
export function sOf(x, z) {
  const d = [z + D / 2, W / 2 - x, D / 2 - z, x + W / 2];
  const k = d.indexOf(Math.min(...d));
  return [x + W / 2, W + z + D / 2, W + D + W / 2 - x, 2 * W + D + D / 2 - z][k];
}

export const zoneRanges = [[59.5, 74], [20, 34.5], [2, 20], [34.5, 47], [47, 59.5]];
export const sectionOf = (p) => (SECTIONS[p.section] ? p.section : "love");
